interface Props {
    vinOrModel?: string;
    vin?: string;
    year?: string;
}

export const getParamVin = (props: Props) => {
    const isItAVin = (input: string | undefined) => {
        const vinRegex = new RegExp('^[A-Za-z0-9]{17}$');
        if (!vinRegex.test(input as string)) {
            return false;
        }
        return true;
    };

    return (props.vinOrModel || props.vin) &&
        !props.year &&
        isItAVin(props.vinOrModel || props.vin)
        ? props.vinOrModel || props.vin
        : '';
};
